<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Making Teca', route: '/backoffice/making-teca/' }, { label: 'Aggiungi Post', route: '/backoffice/making-teca/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Aggiungi post</h1>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formPost" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati post</h2>
            <span class="ac-meta">titolo, data e immagine di copertina</span>
        </div>

        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>* Titolo</label>
                <input type="text" pInputText class="w-full" placeholder="Titolo" formControlName="titolo" required />
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formPost.get('titolo')?.hasError('required') && (formPost.get('titolo')?.dirty || formPost.get('titolo')?.touched)">Il titolo è obbligatorio.</small>
            </div>
            <div class="fld flex-1">
                <label>* Data</label>
                <p-calendar formControlName="data" placeholder="Data" dateFormat="dd/mm/yy" [showIcon]="true" styleClass="w-full" appendTo="body" />
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formPost.get('data')?.hasError('required') && (formPost.get('data')?.dirty || formPost.get('data')?.touched)">La data è obbligatoria.</small>
            </div>
        </div>

        <div class="fld">
            <app-file-upload [form]="formPost" [control]="'immagine'" [label]="'* Immagine box'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'" (load)="onImmagineUpload($event)"></app-file-upload>
        </div>

        <div class="ac-section-head mt-2">
            <h2>Contenuti</h2>
            <span class="ac-meta">sezioni aggiuntive del post (opzionale)</span>
        </div>

        <ng-container *ngFor="let contenuto of post_data; let i = index">
            <div class="flex flex-col gap-4 pt-4 border-t border-[var(--acc-line,#e3dcce)]">
                <div class="fld">
                    <label>* Titolo</label>
                    <input type="text" pInputText class="w-full" placeholder="Titolo" [formControlName]="'titolo_' + i" />
                </div>
                <div class="fld">
                    <label>Descrizione</label>
                    <p-editor [style]="{ height: '150px' }" [formControlName]="'descrizione_' + i" />
                </div>
                <div class="fld">
                    <app-file-upload [form]="formPost" [control]="'immagine_' + i" [label]="'* Immagine contenuto'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'" (load)="onImmagineContenutoUpload($event, i)"></app-file-upload>
                </div>
                <div class="flex justify-end" *ngIf="post_data.length > 1">
                    <button class="acc-btn acc-btn-ghost" type="button" (click)="onRemoveContenuto(i)">Rimuovi contenuto</button>
                </div>
            </div>
        </ng-container>

        <div class="acc-actions">
            <button class="acc-btn" type="button" (click)="onAddContenuto()">Aggiungi contenuto</button>
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/making-teca">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formPost.valid">Aggiungi post</button>
        </div>
    </form>
</section>
